import { ITab } from '@addToEvent/add-to-event-ui';
import { Component, HostListener, inject, OnDestroy, OnInit } from '@angular/core';
import { CreditBalanceViewDto, Listing } from '@marketplace/api';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { CreditBalanceService } from '@features/account/modules/payment/services';
import { RoutesService, SupplierRoutesEnum } from '@shared/services/routes.service';
import { WindowService } from '@shared/services/window/window.service';
import { AppState, fromAppActions } from '@shared/state';
import { environment } from '@environments/environment';
import { AuthService } from '@shared/services/auth/auth.service';
import { BrandPackService } from '@shared/services/brand-pack/brand-pack.service';
import { ListService } from '@shared/services/list/list.service';
@Component({
    selector: 'marketplace-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class HeaderComponent implements OnInit, OnDestroy {
  private readonly _brandPackService = inject(BrandPackService);
  private _destroy$ = new Subject();

  listing$: Observable<Listing>;
  credits: number;
  creditItems: ITab[] = [];
  paymentsRoute = '';
  isLoadingCreditBalance = false;
  isMobile: boolean;

  constructor(
    private _creditBalanceService: CreditBalanceService,
    private _authService: AuthService,
    private _store: Store<AppState>,
    private _windowService: WindowService,
    private _routesService: RoutesService,
    private _listService: ListService
  ) {}

  ngOnInit() {
    this.isMobile = this._windowService.isMobile();
    this.getCreditBalance();
    this.getCreditRoute();
    this.listing$ = this._listService.getListing$();
  }

  @HostListener('window:resize')
  onResize() {
    this.isMobile = this._windowService.isMobile();
  }

  private getCreditRoute() {
    this._routesService
      .getRoutes([SupplierRoutesEnum.PAYMENTS_BILLING_CREDIT_COUNTER])
      .pipe(takeUntil(this._destroy$))
      .subscribe(([paymentsBillingCreditCounter]) => {
        this.paymentsRoute = paymentsBillingCreditCounter.drupalHref;
      });
  }

  getCreditBalance() {
    this.isLoadingCreditBalance = true;
    this._creditBalanceService
      .getCreditBalance$()
      .pipe(
        filter(creditBalance => !!creditBalance),
        map((creditBalance: CreditBalanceViewDto) => creditBalance.amount)
      )
      .subscribe(credits => {
        this.credits = credits;
        this.isLoadingCreditBalance = false;
      });
  }

  /**
   * Logout the User.
   *
   * Drops the brand pack first, for the same reason the sidebar's logout does: this is a
   * full-page redirect, so a remembered pack would otherwise outlive the session on a
   * shared computer (MP-11488).
   */
  logout() {
    this._authService.unauthenticate().subscribe(() => {
      this._brandPackService.clear();
      this._store.dispatch(new fromAppActions.SetInitialState());
      this._windowService.setHref(environment.logoutRoute);
    });
  }

  ngOnDestroy() {
    this._destroy$.next(true);
    this._destroy$.complete();
  }
}
